import { render, staticRenderFns } from "./newCourseListSmall.html?vue&type=template&id=db60998a&"
import script from "./newCourseListSmall.js?vue&type=script&lang=js&"
export * from "./newCourseListSmall.js?vue&type=script&lang=js&"
import style0 from "./newCourseListSmall.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports